import React, { useState } from 'react'
import { Trans } from 'react-i18next'
import { useBoolean } from 'react-use'

import { FormulaAPI } from '@makyoapp/makyo-sdk'
import { ErrorResponse } from '@makyoapp/makyo-sdk/api/api'
import { IGenerateFormulaWithAIResponse } from '@makyoapp/makyo-sdk/api/Formula'
import { Button, Radio, TextArea } from '@makyoapp/makyo-ui'

import { useCreateColumnContext } from '@/context/CreateColumnContext'
import { useSingleProjectContext } from '@/context/SingleProjectContext'
import { useReqError } from '@/hooks/useReqError'
import { useGridV2Context } from '@/components/GridV2/contexts/GridV2Context'

import { Fld, Lbl } from './shared'

function FieldPrompt() {
  const { id, value, setValue } = useCreateColumnContext()
  const [prompt, setPrompt] = useState(value.formulaOptions.formulaPrompt || '')
  const [isLoading, setIsLoading] = useBoolean(false)
  const printAPIError = useReqError()
  const { project } = useSingleProjectContext()
  const { table } = useGridV2Context()
  const [options, setOptions] = useState<IGenerateFormulaWithAIResponse[]>([])
  const [selected, setSelected] = useState('0')

  return (
    <Fld className='items-start!'>
      <Lbl className='pt-2!'>
        <Trans>Describe what you would like to calculate</Trans>
      </Lbl>
      <div className='w-full'>
        <TextArea
          id={`${id}-formula-prompt`}
          className='w-full!'
          value={prompt}
          onChange={(e) => {
            const val = e.currentTarget.value
            setPrompt(val)
          }}
        />
        <Button
          className='w-full mt-2'
          onClick={async () => {
            if (project) {
              setIsLoading(true)
              try {
                const result = await FormulaAPI.GenerateFormulaWithAI(project.id, table?.id || '', prompt)

                if (result.length > 0) {
                  setValue({
                    formulaOptions: {
                      ...value.formulaOptions,
                      formulaValue: result[0],
                      formulaPrompt: prompt,
                    },
                  })
                }
                if (result.length > 1) {
                  setOptions(result)
                }
              } catch (e) {
                printAPIError(e as ErrorResponse)
              } finally {
                setIsLoading(false)
              }
            }
          }}
        >
          {isLoading ? <span className='loading' /> : <Trans>Generate Formula</Trans>}
        </Button>
        {options.length > 1 && (
          <div>
            {options.map((opt, i) => {
              return (
                <div key={i} className='flex-c text-m-sm'>
                  <Radio
                    value={`${i}`}
                    name='formula-opt'
                    checked={selected === `${i}`}
                    onClick={() => {
                      setSelected(`${i}`)
                      setValue({
                        formulaOptions: {
                          ...value.formulaOptions,
                          formulaValue: opt,
                          formulaPrompt: prompt,
                        },
                      })
                    }}
                  />
                  <div>{opt.Content}</div>
                </div>
              )
            })}
          </div>
        )}
      </div>
    </Fld>
  )
}

function FieldGeneratedFormula() {
  const { id, value } = useCreateColumnContext()

  return (
    <Fld className='items-start!'>
      <Lbl className='pt-2!'>
        <Trans>Formula</Trans>
      </Lbl>
      <TextArea disabled id={`${id}-formula-value`} value={value.formulaOptions.formulaValue.Content} />
    </Fld>
  )
}

export default function FieldFormula() {
  return (
    <>
      <FieldPrompt />
      <FieldGeneratedFormula />
    </>
  )
}
